import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import {DceAjax} from "dce-ajax";
import RefreshableInterface from "./utils/RefreshableInterface";
import OpenDialog from "./modal/OpenDialog";
import LoadableInterface from "./utils/LoadableInterface";

interface AjaxBlockProps {
    loadingClass?: string;
    url?: string;
    replace: boolean;
    loadOnStart: boolean;
}

@Dce("AjaxBlock")
export default class AjaxBlock extends DceComponent<AjaxBlockProps> implements RefreshableInterface, LoadableInterface {

    private logger = Logger.of("AjaxBlock");

    private url: string;

    constructor(elem: DceHTMLElement, props: AjaxBlockProps) {
        super(elem, props);
        this.logger.debug("Init AjaxBlock");
        this.url = this.props.url;

        if(this.props.loadOnStart){
            this.refresh();
        }
    }

    onSubComponentInit(component: string, elem: DceHTMLElement) {
        if(component === 'OpenDialog'){

            console.log("AJAX BLOCK SUBCOMPONENT INIT!!!!", this.elem);

            if(elem.hasAttribute('ajax-block')){

                if(elem.hasAttribute('ajax-block-id')){
                    if(this.elem.id !== elem.getAttribute('ajax-block-id')){
                        return;
                    }
                }

                if(elem.hasAttribute('ajax-block-class')){
                    if(!this.elem.classList.contains(elem.getAttribute('ajax-block-class'))){
                        return;
                    }
                }

                let openDialog = elem.ext.getComponent(component) as OpenDialog;

                openDialog.addOnClose((d,e) => {

                    this.logger.debug("CLOSING DIALOG TO RERESH");

                    if(d.getFormSaved()){

                        if(d.getFormResponse().hasData('reloadUrl')){
                            this.loadUrl(d.getFormResponse().getData('reloadUrl'))
                        }else{
                            this.refresh();
                        }

                    }
                });
            }
        }

    }

    public load(e:Event){
        e.preventDefault();
        let target = e.target as HTMLElement;

        let href = target.getAttribute('href');

        if(!target.hasAttribute('href')){
            while (target && !target.hasAttribute('href')) {
                target = target.parentElement;
            }
            href = target.getAttribute('href');
        }

        if(href){
            this.loadUrl(href);
        }

    }

    public loadUrl(url:string, callback?:() => void){
        this.url = url;
        this.refresh(callback);
    }

    public refresh(callback?:() => void){

        this.elem.classList.add(this.props.loadingClass);

        DceAjax.getInstance()
            .get(this.url)
            .then(resp => {

                this.elem.classList.remove(this.props.loadingClass);

                if(this.props.replace){

                    if(resp.hasResponse()){
                        let respHtml = $(resp.response);
                        $(this.elem).replaceWith(respHtml);

                    }else{
                        $(this.elem).remove();
                    }

                }else{
                    if(resp.hasResponse()){
                        $(this.elem).html(resp.response);
                    }else{
                        $(this.elem).html('');
                    }
                }

                if(callback){
                    callback();
                }

            });

    }


    defaultProps(): Partial<AjaxBlockProps> {
        return {
            loadingClass: 'loading',
            replace: true,
            loadOnStart: false
        }
    }
}
